import AudioMinimalContainer from './AudioMinimalContainer'
import AudioMinimalPresentation from './AudioMinimalPresentation'
import AudioMinimalData from './AudioMinimalData'

export default {
  Container: AudioMinimalContainer,
  Presentation: AudioMinimalPresentation,
  Data: AudioMinimalData,
}
